import styled from 'styled-components';
import DefaultModal from 'components/shared/Modal';

export const Modal = styled(DefaultModal)`
  ._modalContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 40px;
    max-width: 800px;
    width: 100%;
    background-color: #3b302a;
    color: #fff;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  max-width: 400px;

  h2, p {
    margin-bottom: 20px;
  }

  span {
    margin-bottom: 25px;
  }
`;

export const BtnContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
`;

export const Button = styled.button`
  max-width: 200px;
  background-color: #fff;
  color: #3b302a;
  cursor: pointer;
  padding: 10px 15px;
  font-family: ${({ theme }) => theme.font.fontFamily.bold};
  border: none;
  border-radius: 10px;
`;
